import { Sparkles, Linkedin, Facebook, Instagram, Youtube } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Portfolio", id: "portfolio" },
  { label: "Live Demo", id: "live-demo" },
  { label: "Blog", id: "blog" },
  { label: "Contact", id: "contact" },
];

const SOCIALS = [
  { icon: Linkedin, href: "https://linkedin.com" },
  { icon: Facebook, href: "https://facebook.com" },
  { icon: Instagram, href: "https://instagram.com" },
  { icon: Youtube, href: "https://youtube.com" },
];

export default function Footer() {
  const go = (id) => scrollToSection(id);
  return (
    <footer className="relative border-t border-white/10 px-6 pt-16 pb-8" data-testid="footer">
      <div className="mx-auto max-w-7xl grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-[#00E5FF] to-[#7B61FF]">
              <Sparkles className="h-4 w-4 text-[#0B1220]" />
            </span>
            <span className="font-display text-lg font-bold">9noc<span className="text-gradient">AI</span></span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-white/55 leading-relaxed">Transforming Businesses with AI, Automation & Innovation. Enterprise-grade AI solutions for startups, SMEs and enterprises across India.</p>
          <p className="mt-4 text-xs text-white/40">GST No: 06DDIPS3975N1ZN</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Quick Links</div>
          <ul className="space-y-2">
            {LINKS.map((l) => (
              <li key={l.id}><button onClick={() => go(l.id)} className="text-sm text-white/60 hover:text-[#00E5FF] transition-colors" data-testid={`footer-${l.id}`}>{l.label}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-4">Connect</div>
          <div className="flex gap-3">
            {SOCIALS.map((s, i) => {
              const Icon = s.icon;
              return (
                <a key={i} href={s.href} target="_blank" rel="noreferrer" data-testid={`social-${i}`}
                  className="grid h-10 w-10 place-items-center rounded-full glass hover:border-[#00E5FF]/50 hover:text-[#00E5FF] transition-colors text-white/70">
                  <Icon className="h-4 w-4" />
                </a>
              );
            })}
          </div>
          <p className="mt-5 text-sm text-white/50">WhatsApp: +91 7042141004</p>
        </div>
      </div>
      <div className="mx-auto max-w-7xl mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-white/40">© 2026 9nocAI. All Rights Reserved.</p>
        <a href="/admin" className="text-xs text-white/30 hover:text-white/60 transition-colors" data-testid="footer-admin-link">Admin</a>
      </div>
    </footer>
  );
}
